<template>
  <div class="login-app">

    

    <div class="login-container">

      <div class="parent">
        <div class="child childA">
          <p class="text-right">ΠΡΟΩΘΗΣΗ ΚΑΙ ΥΠΟΣΤΗΡΙΞΗ ΠΑΙΔΙΩΝ ΓΙΑ ΤΗΝ ΕΝΤΑΞΗ ΤΟΥΣ<br />ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΕΚΠΑΙΔΕΥΣΗ</p>
        </div>
        <div class="child childB">
          <img class="logo banner" src="@/assets/enarmonisi-oikogeniaki-logo.svg" />
        </div>
        <div class="child childC">
          <p class="text-left">ΠΡΟΣΒΑΣΗ ΠΑΙΔΙΩΝ ΣΧΟΛΙΚΗΣ ΗΛΙΚΙΑΣ, ΕΦΗΒΩΝ ΚΑΙ ΑΤΟΜΩΝ<br />ΜΕ ΑΝΑΠΗΡΙΑ ΣΕ ΥΠΗΡΕΣΙΕΣ
            ΔΗΜΙΟΥΡΓΙΚΗΣ ΑΠΑΣΧΟΛΗΣΗΣ</p>
        </div>
      </div>

      <div class="row top-logos">
        <div class="col-xs-12" style="text-align:center"> <img src="@/assets/logo-child-care.svg" /></div>
      </div>

      <div class="form-container">
        <form class="forms-style" @submit.prevent="onSubmit" autocomplete="off">
          <h2>Είσοδος Χρηστών</h2>
          <div class="message">
            Μπορείτε να εισέλθετε με τους κωδικούς που έχετε για την εφαρμογή
          </div>

          <alert-box :alerts="errors" v-if="errors.length > 0"></alert-box>

          <div class="form-group">
            <label for="email">Email</label>
            <input class="form-field" type="text" id="email" v-model="email" v-focus placeholder="Email" />
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <input class="form-field" type="password" id="password" v-model="password" placeholder="Συνθηματικό" />
          </div>

          <button type="submit" :disabled="inProcess == true">Είσοδος</button>
        </form>

        <div class="taxisnet">
          <h2>Είσοδος με TaxisNet</h2>
          <p>
            Μπορείτε να εισέλθετε στην εφαρμογή χρησιμοποιώντας τους κωδικούς
            σας στο TaxisΝet
          </p>

          <button class="invert" type="button" @click="taxisLogin">
            Είσοδος
          </button>
        </div>
      </div>

       <app-footer />

    </div>

   

  </div>
</template>

<script>
import {
  required,
  email,
  numeric,
  minValue,
  minLength,
  Email,
  sameAs,
  requiredUnless,
} from "vuelidate/lib/validators";
import AlertBox from "../shared/alertBox.vue";
import Footer from "../footer/footer.vue";

export default {
  props: ["jwt"],
  inject: ["mySpinner"],
  components: {
    AlertBox,
    "app-footer": Footer,
  },
  data(AlertBox) {
    return {
      email: "",
      password: "",
      inProcess: false,
      errors: [],
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    async onSubmit() {
      this.$v.$touch();
      this.errors = [];

      if (!this.email) {
        this.errors.push("Το email είναι απαραίτητο.");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Απαιτείται ένα έγκυρο email.");
      }
      if (!this.password) {
        this.errors.push("Το Password είναι απαραίτητο.");
      }

      if (this.$v.$invalid || this.errors.length > 0) {
        return;
      }

      this.mySpinner.val = true;
      this.inProcess = true;

      const formData = {
        email: this.email,
        PassWord: this.password,
      };

      this.$store
        .dispatch("login", formData)
        .then(() => {
          this.inProcess = false;
          this.mySpinner.val = false;
        })
        .catch((error) => {
          this.inProcess = false;
          this.mySpinner.val = false;
          this.errors.push(error.response.data.message);
        });
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    taxisLogin() {
      this.errors = [];
      this.$store
        .dispatch("taxisLogin")
        .then(() => {})
        .catch((error) => {
          this.inProcess = false;
          this.errors.push(error.response.data.message);
        });
    },
  },
  created() {
    if (this.jwt != undefined) {
      this.$store
        .dispatch("taxisAuthenticate", this.jwt)
        .then(() => {})
        .catch((error) => {
          
          this.inProcess = false;
          this.mySpinner.val = false;
          this.errors.push(error.response.data.message);
        });
    }
  },
};
</script>

<style lang="scss" scoped>

.forms-style {
  background: linear-gradient(to bottom, #efefef, #ccc);
}

.top-logos{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.login-app {
  font-size: 1rem;
  color: #222;
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: 1110px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.5);
  padding: 1em;

  h2 {
    margin: 0;
  }
}

.espa {
  max-width: 90vw;
  margin: 1em 0;
}

.login-container .form-container * {
  box-sizing: unset;
}

.login-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  max-width: 768px;

  .form-container {
    display: inline-flex;
    flex-wrap: wrap;
    flex-direction: column;

    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2);
    background: linear-gradient(to bottom, #efefef, #ccc);

    border-radius: 10px;
    overflow: hidden;

    .forms-style,
    .taxisnet {
      font-size: 0.9rem;

      padding: 30px 40px 40px;
      width: calc(100% - 80px);
      text-align: center;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      gap: 10px;
    }

    .taxisnet {
      color: #fff;
      background: linear-gradient(to bottom right, #b3cbed, #263586);
    }
  }
}

.logos-banner{
  //margin-top: 30px;
  width: 100%;
  max-width: 768px;

  [class^="col-"]{
    height: 100%;
  }

  img.logo.banner{
    max-height: 100px;
  }

  p{
    font-size:0.6em;
    font-weight: 400;
    text-transform: uppercase;
    font-style: italic;
  }
}
.parent {
  display: flex;
  

  .child {
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    p{
      font-size: 0.75rem;
       margin: 0;
    }
    img{
      max-height: 55px;
    }
   
  }

  .childA {
    flex-basis: 98%;
    // background-color: turquoise;
  }

  .childB {
    flex: 1;
    // background-color: wheat;
  }

  .childC {
    flex-basis: 98%;
    // background-color: blueviolet;
  }
}



.vcenter {
     display: flex;
    align-items: center;
}

.intelli-dev {
  width: auto;
  text-align: center;
  color: black;
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 13px;
  padding: 10px 0;
  margin: 0 auto;
  bottom: 20px;

  img {
    margin-right: 3px;
    margin-bottom: -2px;
  }
  a {
    font-size: 13px;
    color: #000;
    text-decoration: none;
  }

  .inb {
    font-weight: 800;
  }
}

//================== Responsive ======================

// Descktop
@media all and (min-width: 1201px) {
  .login-app {
    width: 100%;
    min-height: 100vh;
  }
  .login-container {
     margin-top:3%;

    .form-container {
      display: inline-flex;
      flex-wrap: wrap;
      flex-direction: revert;
      min-height: 480px;    

      .taxisnet,
      .forms-style {
        font-size: 1rem;
        padding: 40px 40px 90px;
        width: calc(100% - 80px);
        width: calc(50% - 80px);
      }
    }
  }
}

// TABLETS LANDSCAPE & NETBOOKS
@media all and (min-width: 768px) {
  .login-app {
    width: 90%;
  }
  .login-container {
    .form-container {
      display: inline-flex;
      flex-wrap: wrap;
      flex-direction: revert;
      min-height: 480px;

      .taxisnet,
      .forms-style {
        width: calc(50% - 80px);
      }
    }
  }
}

// TABLETS PORTRAIT & SMARTPHONES LANDSCAPE
@media all and (min-width: 481px) {
}

// mobile
@media all and (max-width: 1200px) {
    .top-logos{
      margin:0.5em auto;
     
      [class^="col-"]{
         text-align: center;
      }
    }
    .logos-banner{
      margin-top: 30px;
      width: 100%;

      .logo{
        width:70px;
        height: 70px;
      }

      [class^="col-"]{
        height: auto;
      }

      p{
        font-size: 0.9em;
        font-weight: 400;
      }
  }
  .parent{
    margin:3rem auto;
  }
}

footer{
  margin-top:40px;
  width: 140%;
  margin-left: -20%;
}

@media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 1024px) {
    footer{
      margin-top:40px;
      width: 100%;
      margin-left: 0%;
    }
}
</style>
